import { render, staticRenderFns } from "./SSIDFIlterItem.vue?vue&type=template&id=a0b25f2c&scoped=true"
import script from "./SSIDFIlterItem.vue?vue&type=script&lang=js"
export * from "./SSIDFIlterItem.vue?vue&type=script&lang=js"
import style0 from "./SSIDFIlterItem.vue?vue&type=style&index=0&id=a0b25f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b25f2c",
  null
  
)

export default component.exports